module.exports = __webpack_public_path__ + "static/media/video-bg-landing.36103292.jpg";